import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Box, Card } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { useGetCustomersWalletQuery } from 'hooks/queries/Customers/useGetCustomersWallets'
import { useCustomerCards } from 'pages/Customers/CustomerCard/hooks/useCustomerCards'
import { CardArt } from './CardArt'
import { CardDetailsActions } from './CardDetailsActions'
import { CardDetailsInfo } from './CardDetailsInfo'
import { CardDetailsInfoSkeleton } from './CardDetailsInfoSkeleton'
import { CardDetailsSidePanel } from './CardDetailsSidePanel'

interface CardDetailsProps {
  onFreeze?: () => void
}

export const CardDetails: React.FC<CardDetailsProps> = ({ onFreeze }) => {
  const { id: customerId = '' } = useParams<{ id?: string }>()
  const { card, isLoading: isCardLoading, isError: isCardError } = useCustomerCards(customerId)

  const {
    data: wallet,
    isLoading: isWalletLoading,
    isError: isWalletError,
  } = useGetCustomersWalletQuery(card?.ledger?.id ?? '', !!card?.ledger?.id)

  const [isCardDetailsPanelOpen, setIsCardDetailsPanelOpen] = useState(false)

  const handleCardDetailsClick = () => {
    setIsCardDetailsPanelOpen(true)
  }

  const isLoading = isCardLoading || isWalletLoading
  const isError = isCardError || isWalletError

  if (isLoading) {
    return (
      <Card variant="static" full>
        <Box flex isFlexWrap align="center" justify="between" gap={16}>
          <Box flex align="center" gap={16} className="flex-shrink-0">
            <CardArt />
            <CardDetailsInfoSkeleton />
          </Box>

          <CardDetailsActions
            card={undefined}
            onFreeze={onFreeze}
            onCardDetailsClick={handleCardDetailsClick}
          />
        </Box>
      </Card>
    )
  }

  if (isError || !card || !wallet) {
    return <RequestErrorStatusCard />
  }

  return (
    <>
      <Card variant="static" full>
        <Box isFlexWrap flex align="center" justify="between" gap={16}>
          <Box flex align="center" gap={16} className="flex-shrink-0">
            <CardArt />
            <CardDetailsInfo card={card} wallet={wallet} />
          </Box>

          <CardDetailsActions
            card={card}
            onFreeze={onFreeze}
            onCardDetailsClick={handleCardDetailsClick}
          />
        </Box>
      </Card>

      <CardDetailsSidePanel
        isOpen={isCardDetailsPanelOpen}
        onClose={() => setIsCardDetailsPanelOpen(false)}
        card={card}
        wallet={wallet}
        onFreeze={onFreeze}
      />
    </>
  )
}
